/** @format */

import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { error, success } from '../../Shared/Components/Toast';
import Master from '../Layouts/Master';
import ClubForm from './ClubForm';
import { submitClubForm } from './clubApi';

const CreateClub = () => {
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleSubmit = async ({ values, files }) => {
    setSubmitLoading(true);

    try {
      await submitClubForm({
        method: 'post',
        url: '/panel/club',
        values,
        files,
      });
      success('باشگاه با موفقیت ثبت شد و در انتظار بررسی است');
      navigate('/panel/clubs/my', { replace: true });
    } catch (err) {
      setSubmitLoading(false);
      const message = err?.response?.data?.message;
      const errors = err?.response?.data?.errors;

      if (errors) {
        Object.values(errors).forEach((messages) => error(messages[0]));
      } else {
        error(message || 'ثبت باشگاه با خطا مواجه شد');
      }
    }
  };

  return (
    <Master>
      <div className='d-flex flex-row align-items-center border-bottom pb-3 my-3'>
        <i className='fad fa-plus-circle f-20 text-secondary mx-2'></i>
        <h1 className='text-secondary f-14 font-weight-bold mb-0'>
          ثبت باشگاه جدید
        </h1>
      </div>

      <div className='card border shadow-sm'>
        <div className='card-body p-4'>
          <ClubForm
            initialValues={{
              title: '',
              address: '',
              phone: '',
              province_id: '',
              city_id: '',
              coach_national_code: '',
            }}
            onSubmit={handleSubmit}
            submitLoading={submitLoading}
            submitLabel='ثبت باشگاه'
          />
        </div>
      </div>
    </Master>
  );
};

export default CreateClub;
